import { memo, SVGProps } from 'react';

const SvgIcoStar = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 25 24" {...props}>
    <g id="Star" clipPath="url(#clip0_6764_1828)">
      <path
        id="Star_2"
        d="M12.346 1.93157C12.551 1.43879 13.249 1.43879 13.454 1.93157L15.9333 7.89254C16.0197 8.10028 16.2151 8.24222 16.4393 8.2602L22.8747 8.77612C23.4067 8.81877 23.6224 9.48268 23.2171 9.82988L18.314 14.0299C18.1431 14.1763 18.0685 14.4059 18.1207 14.6248L19.6187 20.9046C19.7425 21.4237 19.1778 21.8341 18.7223 21.5559L13.2127 18.1906C13.0207 18.0734 12.7793 18.0734 12.5872 18.1906L7.07766 21.5559C6.6222 21.8341 6.05745 21.4237 6.18129 20.9046L7.67926 14.6248C7.73146 14.4059 7.65684 14.1763 7.48596 14.0299L2.58289 9.82988C2.17757 9.48268 2.39328 8.81877 2.92527 8.77612L9.36065 8.2602C9.58492 8.24222 9.78029 8.10028 9.86669 7.89254L12.346 1.93157Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_6764_1828">
        <rect width={24} height={24} transform="translate(0.899994)" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgIcoStar);
export default Memo;
